import HonjoLogo from './HonjoLogo.vue'

export { HonjoLogo }
